import { BlueprintFormData } from '../types';
import { buildCalculations } from './buildCalculations';
import { projectTypeStringToId } from 'pages/Blueprints/components/utils';
import { powerProfileModes } from 'greener-ui-library';

export const buildUpdatePayload = (formData: BlueprintFormData) => {
  const calculations = buildCalculations(formData);

  // Check if power profile was edited (different from raw or raw doesn't exist)
  let powerProfileCsv: File | undefined;
  const editedCsvData = formData.editedPowerProfileCsv || formData.rawPowerProfileCsv;

  if (editedCsvData) {
    // Always use text/csv MIME type - backend processes all file types and returns CSV
    // Using getMimeType can cause issues when originalFileName has .xlsx/.xls extension
    // but the data is actually CSV format
    const fileName = formData.originalFileName ? `edited-${formData.originalFileName}` : 'edited-power-profile.csv';
    const mimeType = 'text/csv';
    const csvBlob = new Blob([editedCsvData], { type: mimeType });
    powerProfileCsv = new File([csvBlob], fileName, { type: mimeType });
  }
  
  const powerProfileCreateMode = formData.powerProfileMode === powerProfileModes.manual ? 'manual' : 'file';

  return {
    name: formData.blueprintName,
    organisation_name: formData.clientName,
    ts_start: formData.startDate instanceof Date ? formData.startDate.toISOString() : new Date().toISOString(),
    ts_end: formData.endDate instanceof Date ? formData.endDate.toISOString() : null,
    project_type_id: formData.applicationType ? projectTypeStringToId(formData.applicationType) : -1,
    calculations,
    power_profile_create_mode: powerProfileCreateMode as 'manual' | 'file',
    ...(powerProfileCsv && { power_profile_csv: powerProfileCsv }),
  };
};
